import { render, staticRenderFns } from "./ClientScoring.vue?vue&type=template&id=a71dd73a&scoped=true"
import script from "./ClientScoring.vue?vue&type=script&lang=js"
export * from "./ClientScoring.vue?vue&type=script&lang=js"
import style0 from "./ClientScoring.vue?vue&type=style&index=0&id=a71dd73a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71dd73a",
  null
  
)

export default component.exports